import React from "react";
import { ImageIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Ad } from "@/models/ad";
import AdCard from "./AdCard";

interface AdListProps {
  ads: Ad[];
  openEditDialog: (ad: Ad) => void;
  openDeleteDialog: (ad: Ad) => void;
  openAddDialog: () => void;
  canEditOrDeleteAd: (adSellerId: string) => boolean;
}

const AdList: React.FC<AdListProps> = ({
  ads,
  openEditDialog,
  openDeleteDialog,
  openAddDialog,
  canEditOrDeleteAd
}) => {
  if (ads.length === 0) {
    return (
      <div className="px-6 py-12 text-center">
        <div className="flex flex-col items-center">
          <ImageIcon className="h-12 w-12 text-muted-foreground/30 mb-4" aria-label="No hay anuncios" />
          <p className="font-medium">No hay anuncios registrados</p>
          <p className="text-muted-foreground">
            Ve a Facturación para crear anuncios
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
      {ads.map((ad) => (
        <AdCard
          key={ad.id}
          ad={ad}
          openEditDialog={openEditDialog}
          openDeleteDialog={openDeleteDialog}
          canEditOrDeleteAd={canEditOrDeleteAd}
        />
      ))}
    </div>
  );
};

export default AdList;
